export type ReactInputEvent = React.ChangeEvent<HTMLInputElement>;
export interface User {
  idToken: string;
  refreshToken: string;
  userId: string;
}

export type AuthMap = Record<string, string>;

export interface ListPlaylistInput {
  userId: string;
}

export type ListPlaylistOutput = Array<{
  playlistId: string;
  userId: string;
  playlistName: string;
}>;

export interface CreatePlaylistInput {
  userId: string;
  playlistId: string;
}

export interface CreatePlaylistOutput {
  playlistName: string;
}

export interface DeletePlaylistInput {
  userId: string;
  playlistId: string;
}

export interface CreateSongInput {
  artistName: string;
  songName: string;
  shortDescription: string;
  longDescription: string;
  image: string;
  genres: string;
  genreCategory: string;
}

export interface DeleteSongInput {
  songId: string;
}

export type ListSongsOutput = Array<{
  songId: string;
  artistName: string;
  songName: string;
  shortDescription: string;
  imageId: string;
  genres: string[];
  genreCategory: string;
}>;

export interface GetSongInput {
  songId: string;
}

export interface GetSongOutput {
  songId: string;
  artistName: string;
  songName: string;
  shortDescription: string;
  longDescription: string;
  imageId: string;
  genres: string[];
}

export interface AuthenticateInput {
  code: string;
}

export interface AuthenticateOutput {
  idToken: string;
  accessToken: string;
  refreshToken?: string;
  expiresIn: string;
  tokenType: string;
}

export interface RefreshAuthInput {
  refreshToken: string;
}

export interface ListRecordsInput {
  username: string;
}

export interface UnescoSite {
  siteName: string;
  subSiteName: string;
  country: string;
  latitude: number;
  longitude: number;
  unescoId: string;
  visited?: boolean;
}

export interface Location {
  locationName: string;
  country: string;
  latitude: number;
  longitude: number;
}

export type Photo = (UnescoSite | Location) & {
  photoId: string;
  createdAt: string;
};

export interface Marker {
  latitude: number;
  longitude: number;
}

export interface Map {
  mapId: string;
  name: string;
  markers: Marker[];
}

export type ListUnescoSitesOutput = UnescoSite[];

export type ListLocationsOutput = Location[];

export enum PhotographyViewType {
  GALLERY = 'gallery',
  MAP = 'map',
}

export type ListPhotosOutput = Photo[];

export type CreatePhotoInput = (UnescoSite | Location) & {
  photoId: string;
};

export interface DeletePhotoInput {
  photoId: string;
}

export type ListMapsOutput = Map[];

export type GetMapOutput = Map;

export interface DeleteMapInput {
  mapId: string;
}
